export const productsData = [
  {
    id: 'burners',
    name: 'All Types of Burners',
    category: 'Burners & Chucks',
    badge: 'Solid Brass',
    image: '/products/burners.jpg',
    description: 'Precision brass and high-temp alloy oxy-gas burners designed for uniform flame distribution during ampoule sealing and vial pre-heating.',
    specs: [
      { label: 'Material', value: 'Solid Brass' },
      { label: 'Application', value: 'Ampoule Sealing' },
      { label: 'Gas Type', value: 'LPG / Methane / O2' },
      { label: 'Tolerance', value: 'High Precision Jet' }
    ],
    icon: 'fa-fire-alt',
    iconColor: 'text-danger'
  },
  {
    id: 'upper-chuck',
    name: 'Upper Chuck Spares',
    category: 'Burners & Chucks',
    badge: 'Zero-Runout',
    image: '/products/upper_chuck.jpg',
    description: 'Upper chuck assemblies and replacement collets precision-ground to securely grip glass bodies without micro-fractures.',
    specs: [
      { label: 'Material', value: 'Hardened Tool Steel' },
      { label: 'Application', value: 'Ampoule Gripping' },
      { label: 'Concentricity', value: 'Within 0.005mm' },
      { label: 'Hardness', value: '58 - 62 HRC' }
    ],
    icon: 'fa-cog',
    iconColor: 'text-primary'
  },
  {
    id: 'lower-chuck',
    name: 'Lower Chuck Spares',
    category: 'Burners & Chucks',
    badge: 'Wear-Resistant',
    image: '/products/lower_chuck.jpg',
    description: 'Heavy-duty lower chuck components engineered for smooth vertical movement and long lifecycle under continuous production.',
    specs: [
      { label: 'Material', value: 'Alloy Steel' },
      { label: 'Application', value: 'Vial & Ampoule Rotation' },
      { label: 'Surface Finish', value: 'Super-Finished Ra < 0.2' },
      { label: 'Compatibility', value: 'Universal Lines' }
    ],
    icon: 'fa-cogs',
    iconColor: 'text-warning'
  },
  {
    id: 'shafts',
    name: 'High-Tolerance Drive Shafts',
    category: 'Ampoule & Vial Spares',
    badge: 'Hard Chrome Plated',
    image: '/products/shafts.jpg',
    description: 'Main drive shafts, cam shafts, and spindle shafts precision-turned and balanced for vibration-free machine operation.',
    specs: [
      { label: 'Material', value: 'EN24 / EN19 Hardened' },
      { label: 'Plating', value: 'Hard Chrome 25 Micron' },
      { label: 'Straightness', value: '±0.005mm over length' },
      { label: 'Machining', value: 'Cylindrical Ground' }
    ],
    icon: 'fa-arrows-alt-h',
    iconColor: 'text-info'
  },
  {
    id: 'device-assemblies',
    name: 'Device Assemblies & Forming Tooling',
    category: 'Ampoule & Vial Spares',
    badge: 'Micro-Engineered',
    image: '/products/device_assemblies.jpg',
    description: 'Forming rollers, cutters, needle holders, and custom device sub-assemblies built for high-speed automated packaging machinery.',
    specs: [
      { label: 'Material', value: 'SS 316L / Tool Steel' },
      { label: 'Application', value: 'Neck Forming & Cutting' },
      { label: 'Durability', value: 'Extended Wear Life' },
      { label: 'Inspection', value: '100% Optical Tested' }
    ],
    icon: 'fa-microchip',
    iconColor: 'text-success'
  },
  {
    id: 'sm3-spares',
    name: 'SM-3 Machine Spares',
    category: 'SM-3 Spares',
    badge: 'OEM Direct Fit',
    image: '/products/sm3.jpg',
    description: 'Specialized replacement gears, index plates, cam tracks, and mechanical linkages purpose-built for SM-3 packaging machines.',
    specs: [
      { label: 'Compatibility', value: 'SM-3 Machine Models' },
      { label: 'Components', value: 'Gears, Cams, Indexers' },
      { label: 'Heat Treatment', value: 'Case Hardened' },
      { label: 'Fitment', value: 'Direct Plug-and-Play' }
    ],
    icon: 'fa-industry',
    iconColor: 'text-dark'
  },
  {
    id: 'custom-parts',
    name: 'Custom-Engineered Precision Parts',
    category: 'Custom Tooling',
    badge: 'Reverse Engineering',
    image: '/products/custom_parts.jpg',
    description: 'Tailor-made components fabricated from engineering drawings, CAD models, or damaged sample parts for rapid breakdown turnaround.',
    specs: [
      { label: 'Input Formats', value: '2D Drawing / 3D CAD' },
      { label: 'Batch Size', value: 'Prototypes to Batches' },
      { label: 'Lead Time', value: 'Emergency Dispatch' },
      { label: 'Quality', value: 'Complete QC Report' }
    ],
    icon: 'fa-star',
    iconColor: 'text-primary'
  },
  {
    id: 'construction-devices',
    name: 'Construction Devices & Fixtures',
    category: 'Custom Tooling',
    badge: 'Custom Fabricated',
    image: '/products/construction_devices.jpg',
    description: 'Robust assembly jigs, mounting fixtures, and alignment devices manufactured to enhance line setup and maintenance speed.',
    specs: [
      { label: 'Material', value: 'Structural Alloy / SS 304' },
      { label: 'Function', value: 'Line Setup & Calibration' },
      { label: 'Design', value: 'Rigid & Ergonomic' },
      { label: 'Customization', value: 'Custom Built to Plant' }
    ],
    icon: 'fa-tools',
    iconColor: 'text-secondary'
  }
];
